import JTOObject from '../utils/jto/JTOObject';
import JTOSimple from '../utils/jto/JTOSimple';
import JTOProperty from '../utils/jto/JTOProperty';
import JTORelProperty from '../utils/jto/JTORelProperty';
import JTOList from '../utils/jto/JTOList';
import JTOElement from '../utils/jto/JTOElement';
import FileSuper from './FileSuper';

export default class Section extends JTOObject {
    public static _TYPE: string = 'Section';

    public _name: JTOProperty<string>;
    public _position: JTOProperty<number>;
    private _subSectionList: JTOList<Section>;

    constructor(parent?: JTOElement | null) {
        super(Section._TYPE, parent);
        this._name = new JTOProperty<string>('name', this);
        this._position = new JTOProperty<number>('position', this);
        this._subSectionList = new JTOList<Section>(
            Section,
            'has_sub_section',
            this,
        );
    }

    public get name(): string {
        return this._name.get();
    }

    public set name(value: string) {
        this._name.set(value);
    }

    public get position(): number {
        return this._position.get();
    }

    public set position(value: number) {
        this._position.set(value);
    }

    public get subSectionList(): Section[] {
        return this._subSectionList.getList();
    }

    public set subSectionList(value: Section[]) {
        this._subSectionList.setList(value);
    }
}
